import { render, staticRenderFns } from "./OurServicesSection.vue?vue&type=template&id=30582be4&scoped=true"
import script from "./OurServicesSection.vue?vue&type=script&lang=js"
export * from "./OurServicesSection.vue?vue&type=script&lang=js"
import style0 from "./OurServicesSection.vue?vue&type=style&index=0&id=30582be4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30582be4",
  null
  
)

export default component.exports